import { createSelector } from '@ngrx/store';
import { getMessagesState } from '../messages.selectors';

export const leadsState = createSelector(
  getMessagesState,
  (state) => state.leadsState
);
export const leadsData = createSelector(leadsState, (state) => state.data);
export const leadsIsLoading = createSelector(
  leadsState,
  (state) => state.isLoading
);
export const leadsSuccess = createSelector(
  leadsState,
  (state) => state.success
);
export const leadsError = createSelector(leadsState, (state) => state.error);

export const leadsHasBeenFetched = createSelector(
  leadsState,
  (state) => state.fetched
);
